import { ApolloError } from '@apollo/client'
import { logger } from '@/utils/logging'

export const handleCartUnknownError = (error: unknown, context: ShopifyErrorContext) => {
  let message = 'An unknown error occurred'

  if (error instanceof ApolloError) {
    if (error.graphQLErrors.length > 0) {
      message = error.graphQLErrors.map((e) => e.message).join(', ')
    } else if (error.networkError) {
      message = `Network error: ${error.networkError.message}`
    } else {
      message = error.message
    }
  } else if (error instanceof Error) {
    message = error.message
  }

  notifyDatadogShopify('Shopify Cart Unexpected Error', { context, error: { message } })

  return {
    cart: null,
    errors: [{ message, field: null, code: null }],
  }
}

export type ShopifyErrorContext =
  | 'CreateShopifyCart'
  | 'AddLinesShopifyCart'
  | 'RemoveLinesShopifyCart'
  | 'UpdateLinesShopifyCart'
  | 'ApplyDiscountCode'

interface ShopifyDatadogMetadata {
  context: ShopifyErrorContext
  error?: { message: string }
  [p: string]: { message: string } | string | undefined
}

export const notifyDatadogShopify = (error: string, metadata: ShopifyDatadogMetadata) => {
  logger().error(`Critical Shopify Failure`, { metadata, error })
}
